import React from 'react';
import './LoadingModal.css';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/i18n';

const LoadingModal = ({ isVisible, title, message, isError = false }) => {
  const { language } = useLanguage();
  const defaultTitle = title || t('common.loadingModalDefaultTitle', language);
  const defaultMessage = message || t('common.loadingModalDefaultMessage', language);
  
  if (!isVisible) return null;

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal">
        {!isError && (
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        )}
        <div className="loading-content">
          <h3 className={`loading-title ${isError ? 'text-danger' : ''}`}>{defaultTitle}</h3>
          <p className={`loading-message ${isError ? 'text-danger fw-bold' : ''}`}>{defaultMessage}</p>
          {isError && (
            <div className="mt-3">
              <button 
                className="btn btn-primary btn-sm" 
                onClick={() => window.location.reload()}
              >
                {t('common.loadingModalCloseAndReload', language)}
              </button>
            </div>
          )}
          {!isError && (
          <div className="loading-steps">
            <div className="loading-step">
              <span className="step-icon">🔗</span>
              <span>{t('common.loadingModalConnecting', language)}</span>
            </div>
            <div className="loading-step">
              <span className="step-icon">🧠</span>
              <span>{t('common.loadingModalAnalyzing', language)}</span>
            </div>
            <div className="loading-step">
              <span className="step-icon">🎬</span>
              <span>{t('common.loadingModalGenerating', language)}</span>
            </div>
            <div className="loading-step">
              <span className="step-icon">🔍</span>
              <span>{t('common.loadingModalDetecting', language)}</span>
            </div>
            <div className="loading-step">
              <span className="step-icon">💾</span>
              <span>{t('common.loadingModalSaving', language)}</span>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;
